export const GET_PHOTOGRAPHER_INVOICE_LISTS_SUCCESS = 'GET_PHOTOGRAPHER_INVOICE_LISTS_SUCCESS';
export const GET_PHOTOGRAPHER_INVOICES_FILTER_SUCCESS = 'GET_PHOTOGRAPHER_INVOICES_FILTER_SUCCESS';
export const GET_PHOTOGRAPHER_INVOICE_SUCCESS = 'GET_PHOTOGRAPHER_INVOICE_SUCCESS';
export const CLEAR_PHOTOGRAPHER_INVOICES_FILTER_PLACEHOLDER =
    'CLEAR_PHOTOGRAPHER_INVOICES_FILTER_PLACEHOLDER';
export const CLEAR_PHOTOGRAPHER_INVOICES_STATE = 'CLEAR_PHOTOGRAPHER_INVOICES_STATE';
export const CLEAR_PHOTOGRAPHER_INVOICE_LISTS_STATE = 'CLEAR_PHOTOGRAPHER_INVOICE_LISTS_STATE';
